<template>
  <!-- 订单核销 -->
  <div>
    <cube-page type="myorder-view" title="客户签约" :isback="false">
      <div slot="content">
        <div class="wirte-box">
          <h3 class="tip">为保障您的权益，请扫码或点击链接签署《跟团游合同》,请务必一定签署！！！</h3>
          <van-form @submit="onSubmit">
            <van-field v-model="tel" name="tel" placeholder="输入手机号查询订单签约地址" error clearable
              :rules="[{validator:usernameValidator}]" @clear="clearSearch" />
            <div style="margin-top: 30px;">
              <van-button block type="primary" native-type="submit">确定</van-button>
            </div>
          </van-form>
        </div>
        <div class="vancollapse" v-if="list.length>0">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <van-collapse v-model="activeName" accordion>
                <van-collapse-item :title="`订单号：${item.order_no}`" :name="index" v-for="(item,index) in list"
                  :key="index">
                  <div class="itembox">
                    <div class="itemright ells">
                      <div class="code-img" v-if="item.code_url">
                        <van-image :src="item.code_url" alt="二维码">
                          <template v-slot:error>加载失败</template>
                        </van-image>
                      </div>
                      <div class="itemxx" @click="gotoSigning(item)">
                        签约地址：
                        <span class="ells" style="color: blue;">
                          {{item.link_url}}
                        </span>
                      </div>
                      <div class="itemxx">
                        产品：
                        <span class="ells">{{item.goods_name}}</span>
                      </div>
                      <div class="itemxx">
                        规格：
                        <span class="ells">{{item.goods_attr}}</span>
                      </div>
                      <div class="itemxx">
                        使用日期：
                        <span>{{item.use_date}}</span>
                      </div>
                      <div class="itemxx">
                        联系人：
                        <span>{{item.contacts}}</span>
                      </div>
                      <div class="itemxx">
                        联系电话：
                        <span>{{item.telephone}}</span>
                      </div>
                      <div class="itemxx">
                        订单票数：
                        <span>× {{item.total_num}}</span>
                      </div>
                      <div style="color: red" class="itemxx itemxx-last" v-for="(value,i) in item.travel_text" :key="i">
                        <div v-if="item.travel_text.length > 0">
                          <div>行程-{{i+1}}</div>
                          <div v-for="(text,x) in value" :key="x">
                            {{text.label}}：{{text.value}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </cube-page>
    <cube-view></cube-view>
    <van-popup v-model="boxshow" class="boxshow" style="width: 80%">
      <div class="box-main">
        <div class="box-title">出行通知</div>
        <div class="box-list">
          <div class="box-item" v-for="(item,index) in traveltext" :key="index">
            <span>{{item.title}}</span>
            <span>{{item.intro}}</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import CubeView from '@/components/TP/cube-view'
  import CubePage from '../TP/cube-page.vue'
  import * as util from '@/utils/network'
  import {
    Toast
  } from 'vant'

  export default {
    components: {
      CubePage,
      CubeView,
    },
    data() {
      return {
        list: [],
        orderId: this.$route.query.id,
        tel: '',
        activeName: 0,
        boxshow: false,
        traveltext: [], // 弹出框内容
        loading: false,
        finished: false,
        refreshing: false,
        listpage: 1,
      }
    },
    activated() {

    },
    created() {

    },
    methods: {
      // 请求数据
      onLoad() {
        if (this.refreshing) {
          this.clearData();
        }
        // http://localhost:8081/api/addons/litestore/api.account/getCode?token=c9607cc7-000c-46be-9e60-c1f9d8659f66
        var url = "/addons/litestore/api.account/getSigning"
        //这里直接调用网络接口
        let _that = this;
        util.post(url, {
            id: this.orderId,
            search: this.tel,
            page: this.listpage
          },
          function(res) {
            let resdataaa = res.data;
            if (resdataaa.length == 0) {
              _that.finished = true;
              return false
            }
            _that.list = _that.list.concat(resdataaa);
            _that.loading = false;
            _that.listpage++
          },
        );
      },
      // 清空搜索
      clearSearch() {
        // let that = this;
        this.list = []
        this.page = 1;
        this.finished = false;
      },
      // 点击确认
      onSubmit() {
        if (!this.orderId && !this.tel) {
          this.clearData();
          return
        }
        this.listpage = 1;
        this.clearData();
        this.onLoad()
      },
      // 初始化数据
      clearData() {
        this.list = [];
        this.refreshing = false;
        this.listpage = 1;
      },
      // 上拉刷新
      onRefresh() {
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      },
      // 点击获取时弹出
      popupbox(item) {
        this.boxshow = true;
        this.traveltext = item;
      },
      // 表单验证
      usernameValidator(val) {
        if (val === '') {
          Toast('请输入证件号或手机号码');
          if (this.orderId || this.tel) {
            this.clearData();
          }
        }
      },
      // 跳转
      gotoSigning(item) {
        if (item.link_url) {
          window.location.href = item.link_url
        }
      },
    }
  }
</script>
<style lang="less" scoped="scoped">
  @import url("../../assets/css/listboxless.less");

  .tt-wirte {
    padding: 20px;
    background-color: #FFFFFF;
  }

  .wirte-box {
    margin-top: 30px;

    .van-form {
      padding: 20px;
    }
  }

  .qrpopup {
    width: 90%;
    text-align: center;

    .ddbox {
      margin-top: 15px;
      width: 85%;
      padding: 10px 15px;
      border-top: 1px solid #e2e2e2;

      .ddtop {
        line-height: 40px;
        text-align: left;
        font-size: 14px;
        font-weight: 600;
      }

      .dditem {
        display: flex;
        font-size: 13px;
        color: #7e7e7e;
        line-height: 24px;

        .dd-title {
          width: 80px;
        }

        .dd-nr {
          flex: 1;
          text-align: left;
        }
      }
    }
  }

  .vancollapse {
    padding: 15px 15px 80px;
  }

  .itembox {
    display: flex;
    align-items: center;
    padding: 5px 0;

    .itemleft {
      width: 60px;
    }

    .itemright {
      flex: 1;
      width: 0;
      text-align: center;


      .itemxx {
        line-height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #666;
      }

      .itemxx-last {
        justify-content: flex-start;
        flex-flow: column;
        text-align: left;
        align-items: flex-start;
      }

      .code-img {
        margin: 0 0 15px;

        .van-image {
          width: 200px;
        }
      }
    }

    .itembtns {
      width: 78px;
    }
  }

  .itembox+.itembox {
    border-top: 1px solid #e5e5e5;
  }

  .gzh-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .tt {
      padding-bottom: 40px;
      margin-top: 5px;
      text-align: center;
      font-weight: 600;
    }
  }

  .item {
    padding: 20px 40px;
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #00c7bd;
    color: #FFFFFF;

    .remark {
      padding: 25px;
      font-size: 16px;
      font-weight: 600;
    }

    .imgcore {
      margin-top: 15px;
      height: 200px;
      width: 220px;
      border-radius: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flex {
      display: flex;
      align-items: center;

      .van-icon {
        font-size: 48px;
        padding-right: 10px;
      }
    }

    .msearch {
      margin: 10px 0;
      height: 30px;
      padding: 0 10px;
      line-height: 30px;
      background-color: #fff;
      border-radius: 5px;
      color: #000;
    }
  }

  .boxshow {
    border-radius: 4px;
    width: 85%;

    .box-main {
      padding: 20px;

      .box-title {
        margin: 0 0 15px;
        font-size: 18px;
        color: #000;
        font-weight: bold;
        text-align: center;
      }

      .box-list {
        .box-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: 35px;
          color: #333;
        }
      }
    }
  }

  /deep/ .van-field__control {
    color: #000 !important;
  }

  .tip {
    //color: red;
    font-size: 15px;
    padding: 10px 15px;
  }
</style>
